import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import NirbhikContent from "../components/NirbhikContent";

function NirbhikVyaktitva() {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/content.txt")
      .then((response) => response.text())
      .then((text) => setContent(text))
      .catch(() => setContent(""));
  }, []);

  return (
    <section className="document-section">
      <Container>
        <NirbhikContent content={content} />
      </Container>
    </section>
  );
}

export default NirbhikVyaktitva;
